module.exports = __webpack_public_path__ + "static/media/pathfinder.2c161852.png";